import Button from 'src/app/components/Button/Button';
import styles from './WelcomeScreenThree.module.scss';
import { t } from 'i18next';

type WelcomeScreenThreePropType = {
  onStartSession?: () => void;
};

function WelcomeScreenThree(props: WelcomeScreenThreePropType) {
  const { onStartSession } = props;

  return (
    <div className={styles.screenContent}>
      <h3 className={styles.heading}>{t('LETS_PRACTICE')}</h3>
      <p className={styles.body}>{t('WELCOME_MESSAGE_THREE')}</p>
      <Button
        buttonText={t('START_SESSION')}
        onClickHandler={onStartSession}
        className={styles.startSessionButton}
      />
    </div>
  );
}

export default WelcomeScreenThree;
